import { Component, OnInit,  ViewChild } from '@angular/core';
import { DashboardService } from '../service/dashboard.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
// import { MatTableDataSource, MatPaginator } from '@angular/material';

import { MatTableDataSource, MatPaginator, MatDatepickerInputEvent, MAT_DATE_FORMATS, DateAdapter } from '@angular/material';
import { FormControl } from '@angular/forms';
import { MatDateFormats, MAT_NATIVE_DATE_FORMATS } from '@angular/material';

export const GRI_DATE_FORMATS: MatDateFormats = {
  ...MAT_NATIVE_DATE_FORMATS,
  display: {
    ...MAT_NATIVE_DATE_FORMATS.display,
    dateInput: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    } as Intl.DateTimeFormatOptions,
  }
};


@Component({
  selector: 'app-claimsportal',
  templateUrl: './claimsportal.component.html',
  styleUrls: ['./claimsportal.component.scss'],
   
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: GRI_DATE_FORMATS },
  ]
})
export class ClaimsportalComponent implements OnInit {

  userdata;
  claimsinfo:any=[];
  searchdata;

  minDate: Date;
  maxDate: Date;

  startDate :any
  endDate  : any


  dataSource = new MatTableDataSource();
  displayedColumns = ['no' ,'clientID','policy_no', 'firstName', 'phone', 'Description','email','date_added']


  @ViewChild(MatPaginator) paginator: MatPaginator;

  length: number;
  pageSize: number= 10;
  pageSizeOptions = [ 10, 20,50,100];



  date = new FormControl(new Date(new Date().setDate(new Date().getDate() - 90)));

  serializedDate = new FormControl((new Date()).toISOString().substring(0,10))
  constructor(private router:Router, private service:DashboardService, private readonly adapter: DateAdapter<Date>) { 


    const currentYear = new Date().getFullYear();
    this.minDate = new Date(currentYear - 2, 0, 1);
    // this.maxDate = new Date(currentYear + 1, 11, 31);
    this.maxDate = new Date(currentYear + 1, 0, 0);


  }



  ngOnInit() {

    this.userdata=JSON.parse(localStorage.getItem('userdata'))


    var today = new Date(); //get todays date
    this.endDate= today.toISOString().substring(0,10) //convert todays date to format eg.2019-08.02 and set it to end date
    
    today.setDate(today.getDate() - 90) // subtract 7 days from todays date
    this.startDate = today.toISOString().substring(0,10)

    this.service.claimProcess({email:this.userdata.email, role :this.userdata.role ,minDate: this.startDate, maxDate : this.endDate}).subscribe(data=>{
     // console.log(data);
     
      
      this.claimsinfo = data['responseData'];
      this.dataSource.data = this.claimsinfo;
      this.dataSource.paginator = this.paginator;
      //this.searchdata = this.quotes;
    })

  }



  find(){
    //email:this.ud.email,minDate:this.topperformstartdate,maxDate:this.topperformenddate,duration:days.toString(), role:this.ud.role}

    

    this.service.claimProcess({email:this.userdata.email, role :this.userdata.role ,minDate: this.startDate, maxDate : this.endDate}).subscribe(data=>{
     // console.log(data);
     
      
      this.claimsinfo = data['responseData'];
      this.dataSource.data = this.claimsinfo;
      this.dataSource.paginator = this.paginator;
      //this.searchdata = this.quotes;
    })



  }


  updateDate1(dateObject) {
    // convert object to string then trim it to yyyy-mm-dd
    const stringified = JSON.stringify(dateObject.value);
    this.startDate = stringified.substring(1, 11);
    // this.applicant.contact[0].dob = dob;
  
    console.log(this.startDate )
  }
  
  
  updateDate2(dateObject) {
    // convert object to string then trim it to yyyy-mm-dd
    const stringified = JSON.stringify(dateObject.value);
    this.endDate = stringified.substring(1, 11);
    // this.applicant.contact[0].dob = dob;
  
    console.log("end date " + this.endDate )
  }
  

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  
  



  search (query: string){
    this.searchdata = (query) ?this.claimsinfo.filter( data => data.client_id.toLowerCase().includes(query.toLowerCase()) ||data.policy_no.toLowerCase().includes(query.toLowerCase()) || data.lastName.toLowerCase().includes(query.toLowerCase()) || data.phone.toUpperCase().includes(query.toUpperCase())) : this.claimsinfo;
  }

    opendocument(documentname:any){
      Swal.showLoading();
      (Swal as any).fire({
       icon: 'success',
        text: 'Loading documents completed',
        timer: 1000,
       showConfirmButton: false
      });
      window.open('https://smartcover-api-dev.azurewebsites.net/smartCover/api/claims/load-image/'+documentname)
    
  }

}
